// extracted by mini-css-extract-plugin
export default {"searchPlaceholderView":"styles_searchPlaceholderView__qL33e","searchPlaceholderText":"styles_searchPlaceholderText__aLbpz"};